export const ROLE = {
  ADMIN: "Admin",
  BUSINESS: "Commercialista",
  USER: "User",
};
export const SUB_ROLE = {
  ADMIN: "Responsabile",
  OPERATOR: "Consulente",
};
